import BasicProduction from "@/views/open_queries/packing_house/BasicProduction.vue";
import Home from "@/views/open_queries/packing_house/Home.vue";

export default [
  {
    path: "/oq/packing_house/basic_production/:packing_house_id",
    name: "oq_packing_house_basic_production_path",
    component: Home,
    props: true
  },
  {
    path: "/oq/packing_house/basic_production/:packing_house_id/:process_id",
    name: "oq_packing_house_basic_production_process_path",
    component: BasicProduction,
    props: true
  }
];
